import { LiveEvent } from '../types/Live';

import BaseAttachmentRepository from '@/repositories/base-attachment-repository';

export default class LiveEventTemplateAttachmentRepository extends BaseAttachmentRepository {
  constructor(event: Partial<LiveEvent>) {
    super(`/live/eventTemplate/${event.id}/attachment`);
  }
}
